import { DOM, COOKIES } from '@app/utils';
import { select, put } from 'redux-saga/effects';
import { getGDPR } from '@app/redux/clientLocale/selectors';
import { getCustomerInternal } from '@app/redux/customer/selectors';
import { showTermsAndPrivacy } from './actions';

export const onAcceptTOS = () => {
  DOM.forceSetCookie(COOKIES.TOS_PRIVACY, true);
};

export function* onSetCustomer() {
  const customer = yield select(getCustomerInternal);
  const isGDPR = yield select(getGDPR);
  const { gdprStatus, loggedIn } = customer;
  if (isGDPR && !gdprStatus && loggedIn) {
    yield put(showTermsAndPrivacy(true));
  }

  if (isGDPR && gdprStatus) {
    yield put(showTermsAndPrivacy(false));
  }
}
